module.exports = __webpack_public_path__ + "assets/media/zoom-mm-asset.546ece58.png";